import { ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ModalDelete = ({ show, handleCancel, handleConfirm }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Title'
      })}
      message={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Description'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
    />
  )
}

ModalDelete.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}

export default ModalDelete
